export default "/assets/images/rookie-parent1.f457ae38f4192a1d.png";